import { useTranslation } from 'react-i18next';

export function NoAccessPage() {
  const { t } = useTranslation();
  return (
    <div className="empty">
      <h1 style={{ marginBottom: 8 }}>{t('noAccess.title')}</h1>
      {t('noAccess.text')}
    </div>
  );
}
